/// <reference path="../dts/jquery.d.ts" />
import { BObject } from "../Objects/BObject";

export class ObjectPropertyUI {

    public static handleUIInput(obj:BObject, uiId : string, value : string){
        if(obj && Number(value)!=NaN){
            switch(uiId){
                case "prop-x":
                    obj.setCentre([parseInt(value),obj.getCentre()[1]]);
                    break;
                case "prop-y":
                    obj.setCentre([obj.getCentre()[0], parseInt(value)]);
                    break;
                case "prop-w":
                    obj.setWH([parseInt(value), obj.getWH()[1]]);
                    break;
                case "prop-h":
                    obj.setWH([obj.getWH()[0], parseInt(value)]);
                    break;
                case "prop-angle":
                    obj.setAngle(Number(value));
                    break;
                case "prop-sf":
                    obj.setFrameRange([parseInt(value), obj.getFrameRange()[1]])
                    break;
                case "prop-ef":
                    obj.setFrameRange([obj.getFrameRange()[0], parseInt(value)]);
            }
        }   
    }

    public static updateUIValues(srcObj:BObject){
        $('#prop-selectedObj').show();
        
        $('#prop-thumbnail').attr("src", srcObj.getImageSrc() as any);
        $('#prop-name').text(srcObj.getId() as any);
        
        if(srcObj.getIsVisible()){
            $('#prop-visibilityBtn').addClass("checked");
        } else {
            $('#prop-visibilityBtn').removeClass("checked");
        }

        $('#prop-x').val(srcObj.getCentre()[0]); //for user XY is center
        $('#prop-y').val(srcObj.getCentre()[1]);
        $('#prop-w').val(srcObj.getWH()[0]);
        $('#prop-h').val(srcObj.getWH()[1]);
        $('#prop-angle').val(srcObj.getAngle());
        $('#prop-sf').val(srcObj.getFrameRange()[0]);
        $('#prop-ef').val(srcObj.getFrameRange()[1]);
    }
}